// elegant asf goated asf
import React from "react";
import { Link } from "react-router-dom";

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <h2>Welcome to BoredGames</h2>
      <p>Some yap about like what the site will do and like games or smth</p>
      <div className="hero-buttons">
        <Link to="/games" className="btn-primary">Play Games</Link>
        <Link to="/about" className="btn-secondary">Learn More</Link>
      </div>
    </section>
  );
};

export default Hero;